module.exports = __webpack_public_path__ + "img/pin4.91a04d8d.svg";